import { Button, FormGroup, Image } from '@starsoft/common/components';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { useForm } from 'react-hook-form';
import FileDragAndDrop from '@/components/core/FileDragAndDrop';
import { useModal, useSearchParams } from '@starsoft/common/hooks';
import { ImageUpload } from '../props';
import { useMemo } from 'react';
import { useSendMessageToAdmin } from '@/hooks/theme/useSendMessageToAdmin';
import { CommonModalsKey } from '@starsoft/common/enums';

export default function ImageUploadContent() {
  const { t } = useTranslation('common');
  const search = useSearchParams();
  const id = search.get('target');
  const image = search.get('image');
  const { sendMessage } = useSendMessageToAdmin();
  const { onClose } = useModal(CommonModalsKey.UploadImage);

  const imageUrl = useMemo(() => {
    return ImageUpload.getImageByType(id as ImageUpload.Enum);
  }, [id]);

  const methods = useForm<any>();
  const {
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = methods;

  function onSubmit(data: any) {
    sendMessage('upload-image', {
      ...data,
      image,
    });
    onClose(true);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.container}>
      <div className={styles.container__content}>
        <FormGroup
          label={t('banner_label_description') as string}
          description={
            t(
              !!id
                ? 'banner_label_orientation_with_example'
                : 'banner_label_orientation_without_example',
            ) as string
          }
        >
          <Image
            className={`${styles.container__image} ${
              id === ImageUpload.Enum.Game
                ? styles['container__image--game']
                : ''
            }`}
            src={imageUrl}
            alt="image"
            width={400}
            height={200}
          />
          <FileDragAndDrop
            isLoading={isSubmitting}
            isError={false}
            progress={0}
            label={t('banner_label_description')}
            removeFile={() =>
              setValue('file', null, {
                shouldDirty: false,
              })
            }
            addFile={file => {
              setValue('files', file, { shouldDirty: true });
            }}
          />
        </FormGroup>
      </div>
      <Button>{t('upload')}</Button>
    </form>
  );
}
